export default __webpack_public_path__ + "static/media/accelego-logo-light.6798a74c.svg";